/* @flow */
import * as React from 'react';

// Styles
import styles from './BraindateParticipantsItemLink.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Hooks
import { useIntl } from 'react-intl';

// Utils
import messages from 'src/shared/app/braindate/l10n/braindateL10n';
import { getUserId } from '@braindate/domain/lib/user/util';

// Types
import type { User } from '@braindate/domain/lib/user/type';
import { generatePath } from 'src/shared/app/base/route/util/routeUtils';
import { userInviteRoute } from 'src/shared/app/base/route/setting/routeSettings';
import LinkButton from 'src/shared/ui/component/link/LinkButton';
import useSelf from 'src/shared/domain/user/hook/useSelf';
import { VARIANT } from 'src/shared/ui/component/button/Button';

type Props = {
  participant: User,
  onClose?: () => void,
};

const useStyles = createUseThemeStyles(styles);

const BraindateParticipantsItemLink = ({ participant, onClose }: Props) => {
  const intl = useIntl();
  const self = useSelf();
  const classes = useStyles();

  if (self && getUserId(self) === getUserId(participant)) return null;

  const href = generatePath(userInviteRoute, { id: getUserId(participant) });

  return (
    <div className={classes.root}>
      <LinkButton
        to={href}
        variant={VARIANT.SECONDARY}
        onClick={onClose}
        layoutClass={classes.link}
      >
        {intl.formatMessage(messages.requestMeet)}
      </LinkButton>
    </div>
  );
};

export default React.memo<Props>(BraindateParticipantsItemLink);
